/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/real_sections.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpRealSections {
  constructor() {
    this.sections = {};
    this.output_sections = {};
  }

  updateRealSections(rC) {
    this.sections = rC;
  }

  updateOutputSections(rC) {
    this.output_sections = rC;
  }

  getSection(id) {
    return this.sections[id];
  }

  getOutputSection(id) {
    return this.output_sections[id];
  }
}

export default LpRealSections;



// WEBPACK FOOTER //
// ./src/app/indexes/real_sections.js